import React, { useEffect } from 'react'
import { useStyles } from './layout.styles'
import { Header } from './header'
import { useUserContext } from 'app/shared/state/user-context'
import { useIsBusyContext } from 'app/shared/state/is-busy-context'
import { WaitComponent } from 'app/shared/components/wait-component'

type Props = {
  children: React.ReactElement
}

const Layout = (props: Props) => {
  const classes = useStyles()
  const isBusyContext = useIsBusyContext()
  const { isBusy } = isBusyContext
  const userContext = useUserContext()
  const { currentUser } = userContext

  useEffect(() => {}, [currentUser, isBusy])

  return (
    <div className={classes.main}>
      {currentUser ? (
        <header>
          <div className={classes.header}>
            <Header />
            {isBusy ? <WaitComponent /> : null}
          </div>
        </header>
      ) : (
        <>
          <div className={classes.backgroundImage}></div>
          <div className={classes.designedBy}>Designed by J. Szulczak</div>
        </>
      )}

      <div className={classes.content}>
        <React.Suspense fallback={<WaitComponent />}>{props.children}</React.Suspense>
      </div>
    </div>
  )
}

export default Layout
